<script lang="ts">
    import {t} from "i18next";
    import IOSAppBadge from "@components/IOSAppBadge.svelte";
    import AndroidAppBadge from "@components/AndroidAppBadge.svelte";
    import {staticRoot} from "@src/appStore";
</script>


<nav>
    <ul>
        <li><a href="#">
            <picture>
                <source srcset={`${$staticRoot}/images/super-sloth-logo@3x.webp`} media="(min-resolution: 3dppx)">
                <source srcset={`${$staticRoot}/images/super-sloth-logo@2x.webp` } media="(min-resolution: 2dppx)">
                <img src={`${$staticRoot}/images/super-sloth-logo.webp`}
                     height={60}
                     width={423}
                     alt="Super Sloth logo">
            </picture>
        </a></li>
        <li style="margin-left: auto; margin-right: 16px;">
            <div class="app-store-positioner">
                <IOSAppBadge />
                <AndroidAppBadge />
            </div>
        </li>
        <li>
            <button>{t("share")}</button>
        </li>
    </ul>
</nav>


<style lang="scss">

  @use "src/scss/colors";

  .app-store-positioner {
    display: flex;
    gap: 4px;
  }

  button {

    --glow-color: rgb(252, 193, 30);
    --glow-spread-color: rgba(191, 123, 255, 0.781);
    --enhanced-glow-color: rgb(252, 255, 255);
    --btn-color: rgb(100, 61, 136);

    letter-spacing: 2px;
    font-size: 18px;
    padding: 8px 32px;
    border-radius: 2px;
    background-color: colors.$yellow;
    border: 0;
    -webkit-box-shadow: 3px 3px 19px -3px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 3px 3px 19px -3px rgba(0, 0, 0, 0.75);
    box-shadow: 6px 6px 19px -6px rgba(colors.$yellow, .3);
    border-bottom: 4px solid darken(colors.$yellow, 20%);


    &:hover {
      cursor: pointer;
      background-color: darken(colors.$yellow, 8%);
    }
  }


  nav {
    padding: 16px 32px;
    //background-color: #A2A6AF;
    //background-color: #696180;
    background-color: #50466B;

    //background-color: #9B925F;
  }

  ul {
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0;
    padding: 0;
  }
</style>
